module.exports = __webpack_public_path__ + "img/LCD_read_write.f7a8e020.jpg";